export default __webpack_public_path__ + "static/media/logo_v.69b7c60a.png";